import { useCallback, useState } from "react";
import AccountPage from "../AccountPage";
import ContactInfoPage from "../ContactInfoPage";
import { useDrawer } from "../DrawerContext";
import ProfilePage from "../ProfilePage";
import ManageCard from "./ManageCard";
import PatientSidebar from "./PatientSidebar";
import SubscriptionHistory from "./SubscriptionHistory";

const tabComponentMap = {
  Account: AccountPage,
  Profile: ProfilePage,
  "Contact Info": ContactInfoPage,
  Cards: ManageCard,
  "Subscription History": SubscriptionHistory,
};

export const navItems = [
  { label: "Account", icon: "🔒", translationKey: "account" },
  { label: "Profile", icon: "👤", translationKey: "profile" },
  { label: "Contact Info", icon: "📞", translationKey: "contactInfo" },
  { label: "Cards", icon: "💳", translationKey: "Cards" },
  {
    label: "Subscription History",
    icon: "📋",
    translationKey: "Subscription History",
  },
];

export const SettingsDashboard = ({ lang = "en" }) => {
  const tabOrder = navItems.map((item) => item.label);

  const { drawerOpen, closeDrawer } = useDrawer();

  const [selectedTab, setSelectedTab] = useState("Account");

  // Save selected tab to localStorage whenever it changes
  const handleTabChange = useCallback(
    (tab) => {
      setSelectedTab(tab);
      localStorage.setItem("patientDashboardSelectedTab", tab);
      closeDrawer(); // Close drawer on tab select (mobile)
    },
    [closeDrawer],
  );

  const goToTab = useCallback(
    (direction) => {
      const idx = tabOrder.indexOf(selectedTab);
      if (direction === "next" && idx < tabOrder.length - 1) {
        const nextTab = tabOrder[idx + 1];
        setSelectedTab(nextTab);
        localStorage.setItem("patientDashboardSelectedTab", nextTab);
      } else if (direction === "prev" && idx > 0) {
        const prevTab = tabOrder[idx - 1];
        setSelectedTab(prevTab);
        localStorage.setItem("patientDashboardSelectedTab", prevTab);
      }
    },
    [selectedTab],
  );

  const SelectedComponent =
    tabComponentMap[selectedTab] ||
    (() => <div className="p-8">Not Found</div>);

  // Drawer overlay for mobile
  return (
    <div className="flex min-h-screen bg-[#f8fafc] relative">
      {/* Sidebar for desktop, Drawer for mobile */}
      <PatientSidebar
        selectedTab={selectedTab}
        onSelectTab={handleTabChange}
        lang={lang}
        isDrawer={drawerOpen}
        onCloseDrawer={closeDrawer}
        items={navItems}
        showBackButton
      />
      {/* Overlay for drawer */}
      {drawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
          onClick={closeDrawer}
        />
      )}
      <div className="flex-1 bg-[#f8fafc] p-0 overflow-visible">
        <SelectedComponent
          lang={lang}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          goToTab={goToTab}
        />
      </div>
    </div>
  );
};
